
import React from 'react';
import { useLocation } from 'react-router';
import Navbar from './Navbar';
import Footer from './Footer';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { pathname } = useLocation();
  const isHome = pathname === '/';
  const isFlyMateApp = pathname === '/flymate';

  return (
    <div className="flex flex-col min-h-screen">
      {!isFlyMateApp && <Navbar />}
      <main className={isFlyMateApp ? 'flex-grow' : 'flex-grow pt-20'}>
        {children}
      </main>
      {/* Home manages its own footer inside the scroll canvas + mobile page */}
      {!isHome && !isFlyMateApp && <Footer />}
    </div>
  );
};

export default Layout;
